export { createAxios, type CreateAxiosOptions } from './createAxios';
export { initSuperTokensWeb, webSessionAdapter } from './superTokensInit';

/**
 * Resolves the same-origin API base path. The web app is always
 * served by the same origin as the NestJS API in production
 * (`apps/server`'s ServeStaticModule), and the Vite dev server
 * proxies `/api` and `/artboard` to `:4000` in development. So the
 * client never needs to know an absolute origin.
 */
export const API_BASE = '/api';

/**
 * Origin used by SuperTokens' `appInfo.apiDomain`. Same as the page
 * origin in production; `window.location.origin` works in dev too
 * because the Vite proxy forwards `/api` to the server.
 */
export function resolveAppOrigin(): string {
  if (typeof window === 'undefined') return 'http://localhost:5175';
  return window.location.origin;
}
